var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeaknessesLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.163,
    height: 21.129,
    viewBox: "0 0 21.163 21.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_830",
    "data-name": "Rectangle 830",
    width: 21.163,
    height: 21.129,
    fill: "#ebf8ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5381",
    "data-name": "Path 5381",
    d: "M2.3,8.635H5.522a.713.713,0,1,0,0-1.425H2.3a.713.713,0,1,0,0,1.425",
    transform: "translate(0.222 1.011)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5382",
    "data-name": "Path 5382",
    d: "M7.239,8.217a.711.711,0,0,0,.5.2h.007a.713.713,0,0,0,.5-1.212l-4.03-4.03A.712.712,0,1,0,3.208,4.186Z",
    transform: "translate(0.421 0.416)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5383",
    "data-name": "Path 5383",
    d: "M7.953,6.2a.713.713,0,0,0,.713-.713V2.267a.713.713,0,0,0-1.425,0V5.492a.714.714,0,0,0,.713.713m0-.143Z",
    transform: "translate(1.016 0.218)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5384",
    "data-name": "Path 5384",
    d: "M11.99,10.953h0a.706.706,0,0,0-.5-.2h-.008a.7.7,0,0,0-.5.213.715.715,0,0,0,0,1l4.033,4.032a.712.712,0,0,0,1.007-1.008Z",
    transform: "translate(1.513 1.508)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5385",
    "data-name": "Path 5385",
    d: "M18.741,1.175l0,0a4.221,4.221,0,0,0-5.842,0L9.531,4.537a3,3,0,0,0-.877,2.116V8.933a.713.713,0,1,0,1.425,0V6.654a1.566,1.566,0,0,1,.46-1.108L13.9,2.185a2.768,2.768,0,0,1,3.831,0,2.71,2.71,0,0,1,0,3.829L14.37,9.376a1.572,1.572,0,0,1-1.111.46H10.978a.713.713,0,1,0,0,1.425h2.29a3,3,0,0,0,2.11-.877L18.741,7.02a4.14,4.14,0,0,0,0-5.845",
    transform: "translate(1.214 0)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5386",
    "data-name": "Path 5386",
    d: "M16.836,10.04H13.611a.713.713,0,0,0,0,1.425h3.225a.713.713,0,1,0,0-1.425",
    transform: "translate(1.81 1.408)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5387",
    "data-name": "Path 5387",
    d: "M10.783,12.867h-.036a.712.712,0,0,0-.676.712V16.8a.712.712,0,1,0,1.424,0V13.58a.7.7,0,0,0-.208-.5.705.705,0,0,0-.5-.21",
    transform: "translate(1.413 1.805)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5388",
    "data-name": "Path 5388",
    d: "M10.582,10.235a.713.713,0,0,0-.713.713v2.284a1.564,1.564,0,0,1-.46,1.106L6.048,17.7a2.768,2.768,0,0,1-3.831,0,2.71,2.71,0,0,1-.059-3.769l.017.007.042-.067L5.58,10.509a1.566,1.566,0,0,1,1.1-.458H8.967a.713.713,0,1,0,0-1.425H6.68A2.991,2.991,0,0,0,4.571,9.5L1.209,12.865A4.133,4.133,0,0,0,7.054,18.71l3.364-3.363a3,3,0,0,0,.877-2.116V10.948a.714.714,0,0,0-.713-.713m0,.143Z",
    transform: "translate(0 1.21)",
    fill: "#ebf8ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeaknessesLight);
export default __webpack_public_path__ + "static/media/weaknesses_light.b6337a2463beff50dc19d9627a929f3f.svg";
export { ForwardRef as ReactComponent };